<div class="error-page">
  <div class="error-header">404</div>
  <div class="error-message fk-h1 "> {{ 'fkErrors.pageNotFound' | translate }}</div>
  <div class="error-description fk-subtitle1">{{ 'fkErrors.pageNotFound404Msg' | translate }}</div>
  <button class="fk-btn fk-btn-tertiary btn-giant-font-size btn-giant-line-height fk-pv5 fk-ph8 error-button" (click)="navigateToStartPage()">{{ 'fkErrors.startPage404ButtonLabel' | translate }}</button>
  <img [src]="logoPath" class="frog-illustration" />
</div>
